/**
 * [resp-img]
 * responsive images via data-resp-img-* attributes
 */
 window.coma = window.coma || {};

 window.coma.footer = (function ($, undefined) {
 
     // PRIVATE FUNCTIONS
     var _private = {
 
         init: function() {
             this.addToggleEvent();
         },
         addToggleEvent: function() {
             $('#footer-toggle').find('a').on('click', function(e) {
                 e.preventDefault();
                 $(this).closest('#footer-mega').toggleClass('active');
             });
         }
     }
 
     // CALL INIT
     $(document).ready(function() {
         _private.init();
     });
 
     // PUBLIC FUNCTIONS
     return {}
 
 }(jQuery));